import React, { useState } from 'react';
import { Modal, Form, Input, Select, Row, Col, DatePicker } from 'antd';
import { User, Building2, Calendar, Users, Briefcase, Star, MessageSquare, FileText, ArrowLeft, ArrowRight, CheckCircle, Loader2 } from 'lucide-react';

// Section components remain similar but with updated styling
function SectionA0({ data, onChange }) {
  const [form] = Form.useForm();

  React.useEffect(() => {
    form.setFieldsValue(data);
  }, [data, form]);

  return (
    <div className="space-y-4">
      <div className="flex items-center gap-2 mb-4">
        <div className="w-8 h-8 rounded-full bg-emerald-50 flex items-center justify-center">
          <User className="w-4 h-4 text-emerald-500" />
        </div>
        <h2 className="text-base font-medium text-gray-700">SECÇÃO A0: PERFIL DO ENTREVISTADO</h2>
      </div>
      <Form form={form} layout="vertical" onValuesChange={(_, v) => onChange(v)} initialValues={data}>
        <Row gutter={16}>
          <Col xs={24} sm={12}>
            <Form.Item label={<span className="text-sm text-gray-600">Nome</span>} name="name"> 
              <Input size="large" placeholder="Introduza o nome completo" className="rounded-lg border-gray-200" />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12}>
            <Form.Item label={<span className="text-sm text-gray-600">Contacto</span>} name="contact">
              <Input size="large" placeholder="Introduza o contacto" className="rounded-lg border-gray-200" />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12}>
            <Form.Item label={<span className="text-sm text-gray-600">Cargo</span>} name="position">
              <Input size="large" placeholder="Introduza o cargo do entrevistado" className="rounded-lg border-gray-200" />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12}>
            <Form.Item label={<span className="text-sm text-gray-600">Data da Entrevista</span>} name="date">
              <DatePicker className="w-full rounded-lg border-gray-200" format="DD/MM/YYYY" placeholder="Selecione a data" size="large" />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </div>
  );
}

function SectionA1({ data, onChange }) {
  const [form] = Form.useForm();

  React.useEffect(() => {
    form.setFieldsValue(data);
  }, [data, form]);

  return (
    <div className="space-y-4">
      <div className="flex items-center gap-2 mb-4">
        <div className="w-8 h-8 rounded-full bg-emerald-50 flex items-center justify-center">
          <Building2 className="w-4 h-4 text-emerald-500" />
        </div>
        <h2 className="text-base font-medium text-gray-700">SECÇÃO A1: PERFIL DA EMPRESA</h2>
      </div>
      <Form form={form} layout="vertical" onValuesChange={(_, v) => onChange(v)} initialValues={data}>
        <Row gutter={16}>
          <Col xs={24} sm={12}>
            <Form.Item label={<span className="text-sm text-gray-600">Nome da Empresa</span>} name="company_name"> 
              <Input size="large" placeholder="Introduza o nome da empresa" className="rounded-lg border-gray-200" />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12}>
            <Form.Item label={<span className="text-sm text-gray-600">Área de Atuação</span>} name="area">
              <Input size="large" placeholder="Indique a área de atuação" className="rounded-lg border-gray-200" />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </div>
  );
}

function SectionA2({ data, onChange }) {
  const [form] = Form.useForm();

  React.useEffect(() => {
    form.setFieldsValue(data);
  }, [data, form]);

  return (
    <div className="space-y-4">
      <div className="flex items-center gap-2 mb-4">
        <div className="w-8 h-8 rounded-full bg-emerald-50 flex items-center justify-center">
          <Calendar className="w-4 h-4 text-emerald-500" />
        </div>
        <h2 className="text-base font-medium text-gray-700">SECÇÃO A2: CARACTERIZAÇÃO DA EMPRESA</h2>
      </div>
      <Form form={form} layout="vertical" onValuesChange={(_, v) => onChange(v)} initialValues={data}>
        <Row gutter={16}>
          <Col xs={24} sm={12}>
            <Form.Item label={<span className="text-sm text-gray-600">Ano de Fundação</span>} name="foundation_year"> 
              <Input type="number" size="large" placeholder="Ex.: 2005" className="rounded-lg border-gray-200" />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12}>
            <Form.Item label={<span className="text-sm text-gray-600">Nº Funcionários</span>} name="employee_count">
              <Input type="number" size="large" placeholder="Ex.: 50" className="rounded-lg border-gray-200" />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </div>
  );
}

function SectionB({ data, onChange }) {
  const [form] = Form.useForm();

  React.useEffect(() => {
    form.setFieldsValue(data);
  }, [data, form]);

  return (
    <div className="space-y-4">
      <div className="flex items-center gap-2 mb-4">
        <div className="w-8 h-8 rounded-full bg-emerald-50 flex items-center justify-center">
          <Users className="w-4 h-4 text-emerald-500" />
        </div>
        <h2 className="text-base font-medium text-gray-700">SECÇÃO B: RELAÇÃO COM A UEM</h2>
      </div>
      <Form form={form} layout="vertical" onValuesChange={(_, v) => onChange(v)} initialValues={data}>
        <Form.Item label={<span className="text-sm text-gray-600">Já contratou graduados da UEM?</span>} name="hired"> 
          <Select size="large" placeholder="Selecione uma opção" className="rounded-lg">
            <Select.Option value="">Selecione</Select.Option>
            <Select.Option value="sim">Sim</Select.Option>
            <Select.Option value="nao">Não</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item label={<span className="text-sm text-gray-600">Comentário</span>} name="comment">
          <Input.TextArea rows={4} placeholder="Adicione comentários relevantes sobre a relação com a UEM" className="rounded-lg border-gray-200" />
        </Form.Item>
      </Form>
    </div>
  );
}

function SectionC({ data, onChange }) {
  const [form] = Form.useForm();
  const items = ['Técnico', 'Comunicação', 'Trabalho em equipa'];

  React.useEffect(() => {
    form.setFieldsValue(data);
  }, [data, form]);

  return (
    <div className="space-y-4">
      <div className="flex items-center gap-2 mb-4">
        <div className="w-8 h-8 rounded-full bg-emerald-50 flex items-center justify-center">
          <Star className="w-4 h-4 text-emerald-500" />
        </div>
        <h2 className="text-base font-medium text-gray-700">SECÇÃO C: COMPETÊNCIAS DOS GRADUADOS</h2>
      </div>
      <Form form={form} layout="vertical" onValuesChange={(_, v) => onChange(v)} initialValues={data}>
        {items.map((it) => (
          <Form.Item key={it} label={<span className="text-sm text-gray-600">{it}</span>} name={it} className="mb-4">
            <Select size="large" placeholder="Selecione uma classificação (1 a 5)" className="rounded-lg">
              <Select.Option value="">-</Select.Option>
              {[1,2,3,4,5].map(n => <Select.Option key={n} value={n}>{n} - {n === 1 ? 'Insuficiente' : n === 5 ? 'Excelente' : ''}</Select.Option>)}
            </Select>
          </Form.Item>
        ))}
      </Form>
    </div>
  );
}

function SectionD({ data, onChange }) {
  const [form] = Form.useForm();

  React.useEffect(() => {
    form.setFieldsValue(data);
  }, [data, form]);

  return (
    <div className="space-y-4">
      <div className="flex items-center gap-2 mb-4">
        <div className="w-8 h-8 rounded-full bg-emerald-50 flex items-center justify-center">
          <Briefcase className="w-4 h-4 text-emerald-500" />
        </div>
        <h2 className="text-base font-medium text-gray-700">SECÇÃO D: RECRUTAMENTO E SATISFAÇÃO</h2>
      </div>
      <Form form={form} layout="vertical" onValuesChange={(_, v) => onChange(v)} initialValues={data}>
        <Form.Item label={<span className="text-sm text-gray-600">Método de Recrutamento</span>} name="method"> 
          <Input size="large" placeholder="Descreva o principal método de recrutamento" className="rounded-lg border-gray-200" />
        </Form.Item>
        <Form.Item label={<span className="text-sm text-gray-600">Nível de Satisfação</span>} name="satisfaction">
          <Select size="large" placeholder="Selecione o nível de satisfação (1 a 5)" className="rounded-lg">
            <Select.Option value="">Selecione</Select.Option>
            {[1,2,3,4,5].map(n => <Select.Option key={n} value={n}>{n} - {n === 1 ? 'Muito Insatisfeito' : n === 5 ? 'Muito Satisfeito' : ''}</Select.Option>)}
          </Select>
        </Form.Item>
      </Form>
    </div>
  );
}

function SectionE({ data, onChange }) {
  const [form] = Form.useForm();

  React.useEffect(() => {
    form.setFieldsValue(data);
  }, [data, form]);

  return (
    <div className="space-y-4">
      <div className="flex items-center gap-2 mb-4">
        <div className="w-8 h-8 rounded-full bg-emerald-50 flex items-center justify-center">
          <MessageSquare className="w-4 h-4 text-emerald-500" />
        </div>
        <h2 className="text-base font-medium text-gray-700">SECÇÃO E: SUGESTÕES E OBSERVAÇÕES</h2>
      </div>
      <Form form={form} layout="vertical" onValuesChange={(_, v) => onChange(v)} initialValues={data}>
        <Form.Item label={<span className="text-sm text-gray-600">Sugestões / Observações</span>} name="text">
          <Input.TextArea rows={5} placeholder="Registe aqui sugestões e observações relevantes sobre os graduados da UEM" className="rounded-lg border-gray-200" />
        </Form.Item>
      </Form>
    </div>
  );
}

function SectionF({ data, onChange }) {
  const [form] = Form.useForm();

  React.useEffect(() => {
    form.setFieldsValue(data);
  }, [data, form]);

  return (
    <div className="space-y-4">
      <div className="flex items-center gap-2 mb-4">
        <div className="w-8 h-8 rounded-full bg-emerald-50 flex items-center justify-center">
          <FileText className="w-4 h-4 text-emerald-500" />
        </div>
        <h2 className="text-base font-medium text-gray-700">SECÇÃO F: DADOS DO INQUIRIDOR</h2>
      </div>
      <Form form={form} layout="vertical" onValuesChange={(_, v) => onChange({ ...v, name: v.name || '' })} initialValues={data}>
        <Row gutter={16}>
          <Col xs={24} sm={12}>
            <Form.Item label={<span className="text-sm text-gray-600">Nome do Inquiridor</span>} name="name"> 
              <Input size="large" placeholder="Introduza o nome do inquiridor" className="rounded-lg border-gray-200" />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12}>
            <Form.Item label={<span className="text-sm text-gray-600">Contacto do Inquiridor</span>} name="contact">
              <Input size="large" placeholder="Introduza o contacto do inquiridor" className="rounded-lg border-gray-200" />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </div>
  );
}

export default function EmployerSurveyPage() {
  const [step, setStep] = useState(0);
  const [formData, setFormData] = useState({
    interview: {},
    company: {},
    characterization: {},
    uem: {},
    skills: {},
    recruitment: {},
    suggestions: {},
    inquirer: {},
  });

  const stepLabels = ['Entrevistado', 'Empresa', 'Caracterização', 'Relação UEM', 'Competências', 'Recrutamento', 'Sugestões', 'Inquiridor'];

  function changeSection(key, value) {
    setFormData(prev => ({ ...prev, [key]: value }));
  }

  function nextStep() {
    setStep(s => Math.min(stepLabels.length - 1, s + 1));
  }

  function prevStep() {
    setStep(s => Math.max(0, s - 1));
  }

  function handleSubmit(e) {
    e.preventDefault();
    if (step < stepLabels.length - 1) {
      nextStep();
      return;
    }

    Modal.confirm({
      title: 'Confirmar submissão',
      content: 'Confirma que deseja submeter o inquérito? Os dados serão enviados.',
      onOk() {
        console.log('Employer survey payload:', formData);
        Modal.success({ title: 'Submetido', content: 'O inquérito foi submetido com sucesso!' });
      }
    });
  }

  return (
    <div className="max-w-6xl mx-auto w-full px-4 sm:px-6 lg:px-8 py-12">
      {/* Header */}
      <div className="mb-8 text-center">
        
      </div>

      <form onSubmit={handleSubmit} className="max-w-3xl mx-auto">
        {/* Progress Steps */}
        <div className="mb-8">
          <div className="flex items-center justify-between">
            {stepLabels.map((label, idx) => (
              <div key={label} className="flex-1 flex flex-col items-center">
                <div
                  className={`w-9 h-9 rounded-full flex items-center justify-center mb-2 text-sm font-medium transition-all ${
                    idx < step
                      ? 'bg-emerald-600 text-white'
                      : idx === step
                      ? 'bg-emerald-50 text-emerald-600 border-2 border-emerald-500'
                      : 'bg-gray-100 text-gray-400'
                  }`}
                >
                  {idx < step ? <CheckCircle className="w-5 h-5" /> : idx + 1}
                </div>
                <div className="text-xs text-gray-500 hidden sm:block">{label}</div>
              </div>
            ))}
          </div>
          <div className="h-1.5 bg-gray-100 rounded-full mt-4 relative overflow-hidden">
            <div
              className="absolute left-0 top-0 h-full rounded-full bg-emerald-500 transition-all duration-300"
              style={{ width: `${(step / (stepLabels.length - 1)) * 100}%` }}
            />
          </div>
        </div>

        {/* Form Card */}
        <div className="bg-white rounded-xl border border-gray-100 shadow-sm overflow-hidden">
          <div className="p-6 md:p-8">
            {step === 0 && <SectionA0 data={formData.interview} onChange={v => changeSection('interview', v)} />}
            {step === 1 && <SectionA1 data={formData.company} onChange={v => changeSection('company', v)} />}
            {step === 2 && <SectionA2 data={formData.characterization} onChange={v => changeSection('characterization', v)} />}
            {step === 3 && <SectionB data={formData.uem} onChange={v => changeSection('uem', v)} />}
            {step === 4 && <SectionC data={formData.skills} onChange={v => changeSection('skills', v)} />}
            {step === 5 && <SectionD data={formData.recruitment} onChange={v => changeSection('recruitment', v)} />}
            {step === 6 && <SectionE data={formData.suggestions} onChange={v => changeSection('suggestions', v)} />}
            {step === 7 && <SectionF data={formData.inquirer} onChange={v => changeSection('inquirer', v)} />}
          </div>

          {/* Navigation Buttons */}
          <div className="bg-gray-50/50 px-6 py-4 border-t border-gray-100 flex items-center justify-between">
            <button
              type="button"
              onClick={prevStep}
              className={`inline-flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                step > 0
                  ? 'text-gray-600 hover:text-emerald-600 hover:bg-gray-100'
                  : 'text-gray-300 cursor-not-allowed'
              }`}
              disabled={step === 0}
            >
              <ArrowLeft className="w-4 h-4" />
              Anterior
            </button>

            <span className="text-xs text-gray-400">
              Passo {step + 1} de {stepLabels.length}
            </span>

            <button
              type="submit"
              className="inline-flex items-center gap-2 bg-emerald-600 hover:bg-emerald-700 text-white px-5 py-2 rounded-lg text-sm font-medium transition-colors shadow-sm"
            >
              {step === stepLabels.length - 1 ? (
                <>
                  Submeter
                  <CheckCircle className="w-4 h-4" />
                </>
              ) : (
                <>
                  Próximo
                  <ArrowRight className="w-4 h-4" />
                </>
              )}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}